"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

var Chart = require("chart.js");

exports.default = {
  props: ["data"],

  mounted: function mounted() {
    this.render();
  },


  methods: {
    render: function render() {
      var myChart = new Chart(this.$refs.canvas, {
        type: "horizontalBar",
        data: {
          labels: this.data.chartsData.labels,
          datasets: [{
            label: "Lower than normal",
            backgroundColor: this.data.chartsData.colors[0],
            data: this.data.chartsData.lowerStats
          }, {
            label: "Normal",
            backgroundColor: this.data.chartsData.colors[1],
            data: this.data.chartsData.normalStats
          }, {
            label: "Over than normal",
            backgroundColor: this.data.chartsData.colors[2],
            data: this.data.chartsData.upperStats
          }]
        },
        options: {
          legend: { display: false },
          title: {
            display: true,
            text: this.data.chartsData.name
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/elements/CompareReportReferenceChart.vue
// module id = nweN
// module chunks = 0 1